<template>
  <div v-if="content" v-editable="content" id="parc-page">
    <component
      :content="blok"
      :key="blok._uid"
      v-for="(blok) in content.body"
      :is="blok.component"
      v-editable="content"
    ></component>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      content: null,
      id: this.$route.params.id
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const res = await api.get(
          `cdn/stories/${this.$i18n.locale}/pages/attractions/${this.id}`
        );
        this.content = res.data.story.content;
      } catch (err) {
        this.$router.push("/404");
      }
    }
  },
  computed: {}
};
</script>

<style lang="scss">
@media screen and (max-width: $tablet) {
  #parc-page {
    video,
    .video-controls {
      height: 350px;
    }
    .attraction-list {
      .list {
        grid-template-columns: repeat(1, 1fr) !important;
      }
    }
    .textBloc {
      padding: 0 1em;
    }
    .btn-list {
      .list {
        margin: 1em 0;
      }
    }
  }
}
</style>
